import { timeSlots } from "./constants";

export default function cuttingTimeSlotsArr(
    slot: string,
): { value: string; label: string }[] {
    const index = timeSlots.findIndex(item => item.value === slot);
    if (index === -1) {
        return [];
    }
    const newTimeSlots = timeSlots.slice(index + 1);
    return newTimeSlots;
}
